import { FC } from 'react';
import rentmoteLogoVert from '@/assets/rentmote-logotipo.png'
import rentmoteLogHor from '@/assets/rentmote-logotipo-horizontal.png'

type LogoHolderProps = {
  width?: string
  height?: string
  horizontal?: boolean
}


export const LogoHolder: FC<LogoHolderProps> = ({ width, height, horizontal }) => {
  return (
    <img src={horizontal ? rentmoteLogHor : rentmoteLogoVert} width={width || 'auto'} height={height || 'auto'} alt="rentmote-logo" />
  )
}